/* eslint-disable max-len */
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ArticlesService } from '../../../services/articles.service';
import { Multitenant } from '../../../services/multitenant.provider';
import { MetaProvider } from '../../../services/meta.provider';
import { PopUpService } from '../../../shared/components/pop-up/pop-up.service';
import { AuthProvider } from '../../../services/auth.provider';
import { PopUp } from '../../../models/popup.model';
import { IonHeader } from '@ionic/angular';

@Component({
  selector: 'app-thematicfilessubcat',
  templateUrl: 'thematicfilessubcat.html',
  styleUrls: ['thematicfilessubcat.scss']
})
export class ThematicfilessubcatPage implements OnInit {
  @ViewChild(IonHeader) header: IonHeader;

  public subCategories: any;
  public categoryName: any;
  public subthemes: any;
  public themeResp: any;
  public subthemesResp: any;
  public themeClass: any;
  public isActivePage: string;
  public themeslug: string;
  public theme: any;
  public popup: PopUp = new PopUp();
  public tempPopUp: boolean;
  public showSpinner: boolean;
  private newspaper: string;

  constructor(
    private actRoute: ActivatedRoute,
    private router: Router,
    private articlesService: ArticlesService,
    private multiTenant: Multitenant,
    private meta: MetaProvider,
    private popUpService: PopUpService,
    private auth: AuthProvider,
    public renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.actRoute.paramMap.subscribe( paramMap => {
      this.newspaper = paramMap.get('newspaper');
      this.themeslug = paramMap.get('themeslug');
      this.getSubCategories(this.themeslug);
    });
  }

  getSubCategories(slug: string) {
    this.showSpinner = true;
    this.articlesService.getThematicFilesSubCategories(slug).subscribe(response => {
      this.showSpinner = false;
      this.meta.clearHead();
      this.themeResp = response;
      this.subthemesResp = response[0].subthemes;
      const title = this.themeResp[0].name + ' | Dossiers d\'actualité ' + this.newspaperName(this.newspaper) + ' | Playbac Presse Digital';
      const description = 'Retrouvez tous nos dossiers d\'actualité liés aux grands événements et aux célébrations historiques, classés par thématique. Consultez-les maintenant !';
      this.meta.addTitle(title);
      this.meta.addDescription(description);
    });
  }

  ionViewWillEnter() {
    this.themeClass = this.multiTenant.getDomainClass();
    this.isActivePage = 'dossiers';
    this.renderer.setStyle(this.header['el'], 'webkitTransition', 'margin-top 700ms');
  }

  ionViewDidEnter() {
    /* UnIdentified pop-up show */
    if (!this.auth.isAuthenticated() && this.popUpService.havePassedSevenDays() && this.multiTenant.getDomainClass() === 'playbacpresse') {
      this.tempPopUp = true;
      this.popup.type = 'unIdentifiedUser';
    }
    /* UnIdentified pop-up show */
}

  goToFileDetail(subcategory) {
    this.router.navigate(['dossiers-actualite', this.newspaper, this.themeslug, subcategory.slug], { queryParams: { name: subcategory.name } });
  }

  newspaperName(newspaper) {
    let newspaperName: string;

    switch (newspaper) {
      case 'lepq':
        newspaperName = 'Le Petit Quotidien';
        break;
      case 'mquo':
        newspaperName = 'Mon Quotidien';
        break;
      case 'aeco':
        newspaperName = 'L\'eco';
        break;
      case 'actu':
        newspaperName = 'L\'actu';
        break;
      default:
        newspaperName = 'PlayBacPresse';
        break;
    }

    return newspaperName;
  }

}
